import React from "react";
import links from "../data-list/links";

const About = () => {
  let imgPath = process.env.PUBLIC_URL + "assets/media/";
  let aboutImage = imgPath + "about.png";

  return (
    <div className="app-about horizontal-about" id="about">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <h2>
                ABOUT <span className="theme-color">Nibebe</span>
              </h2>
              <p>
                Nibebe is a platform that provides ride-hailing, ride-sharing,
                and real-time tracking of public transport vehicles. It is
                powered by crowdsourced data.
              </p>
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-lg-5 offset-lg-1 mt--10">
            <div className="about-thumbnail mr--35">
              <img style={{ height: "70vh" }} src={aboutImage} alt="About" />
            </div>
          </div>
          <div className="col-lg-6 mt--40">
            <div className="about-content">
              <h2 className="title">
                SDG 11.2{" "}
                <span className="theme-color">
                  Affordable and Sustainable Transport Systems
                </span>
              </h2>
              <p>
                We facilitate access to safe, affordable, accessible and
                sustainable transport systems for all with with special
                attention to the needs of those in vulnerable situations, women,
                children, persons with disabilities and older persons.
              </p>
              <p>
                We offer a single platform that provides access to public
                transport, carpools, and ride-hailing. We also integrate these
                services with offline platforms like USSD and SMS to serve
                communities without internet access.
              </p>
              <h2 className="title">
                Your apps are enough.
                <span className="theme-color"> No need to install ours</span>
              </h2>
              <p>
                Our third party integrations allow users to access all of our
                services from their preferred platforms without the need to
                install the nibebe app.
              </p>
              <div className="about-buttons">
                {links.integrations().map((integration) => (
                  <a
                    // role="button"
                    style={{ marginRight: 15 }}
                    // className="button-default button-white button-border"
                    href={integration.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {integration.name}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
